import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "../lib/anim";

const links = [
  { label: "LEARN", target: "#learn" },
  { label: "HOST", target: "#host" },
  { label: "FAQ", target: "#faq" },
];

export const Nav = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 500);
    return () => clearTimeout(t);
  }, []);

  return (
    <nav
      data-testid="floating-nav"
      className={`fixed top-5 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1 sm:gap-2 px-2 py-2 rounded-full border border-white/10 bg-[#091E42]/55 backdrop-blur-xl transition-opacity duration-700 ${visible ? "opacity-100" : "opacity-0"}`}
    >
      <span className="hidden sm:flex items-center justify-center w-8 h-8 rounded-full border border-[#FFFFFF]/60 font-mono text-[10px] text-[#FFFFFF] ml-1">NQ</span>
      {links.map((l) => (
        <button
          key={l.label}
          data-testid={`nav-link-${l.label.toLowerCase()}`}
          onClick={() => scrollToId(l.target)}
          className="px-3 sm:px-4 py-2 font-mono text-[10px] tracking-[0.2em] text-white/60 hover:text-[#FFFFFF] transition-colors duration-200"
        >
          {l.label}
        </button>
      ))}
      <button
        data-testid="nav-register-btn"
        data-cta="true"
        onClick={() => scrollToId("#register")}
        className="flex items-center gap-1.5 bg-[#FFFFFF] text-[#0E2A54] font-bold text-[11px] tracking-wide px-4 sm:px-5 py-2.5 rounded-full hover:bg-[#DCE8FF] transition-colors duration-200"
      >
        BOOK A CALL <ArrowUpRight className="w-3.5 h-3.5" />
      </button>
    </nav>
  );
};
